import { AlertTriangle, RefreshCw } from "lucide-react";

export default function ConnectionError({ error, onRetry }) {
  const isMissingConfig = error?.message === "missing-config";
  return (
    <div
      data-testid="connection-error"
      className="mx-auto my-16 flex max-w-xl flex-col items-start border border-[#1E293B] bg-[#0F172A] p-8"
    >
      <div className="flex items-center gap-3 border-b border-[#1E293B] pb-4">
        <AlertTriangle className="h-6 w-6 text-[#FF5500]" />
        <h3 className="font-display text-2xl tracking-wider text-white">
          {isMissingConfig
            ? "FIREBASE NO CONFIGURADO"
            : "ERROR DE CONEXIÓN"}
        </h3>
      </div>
      <p className="mt-5 font-body text-sm leading-relaxed text-[#94A3B8]">
        {isMissingConfig
          ? "No se encontró la configuración de Firebase. Verifica las variables REACT_APP_FIREBASE_* en tu archivo .env del frontend y reinicia el servidor."
          : "No fue posible conectar con Firebase. Comprueba tu conexión a internet, las reglas de seguridad de Firestore o inténtalo nuevamente."}
      </p>
      {error?.code && (
        <code className="mt-4 block w-full border border-[#1E293B] bg-[#080D1A] p-3 font-mono text-xs text-[#FF5500]">
          {error.code}: {error.message}
        </code>
      )}
      {onRetry && (
        <button
          onClick={onRetry}
          data-testid="retry-connection"
          className="mt-6 inline-flex items-center gap-2 border border-[#FF5500] bg-[#FF5500] px-5 py-2.5 font-ui text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-[#CC3300] hover:border-[#CC3300]"
        >
          <RefreshCw className="h-3.5 w-3.5" />
          Reintentar
        </button>
      )}
    </div>
  );
}
